import { render, staticRenderFns } from "./cleaning-supply-list.view.vue?vue&type=template&id=5a2d207d"
import script from "./cleaning-supply-list.view.vue?vue&type=script&lang=js"
export * from "./cleaning-supply-list.view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports